module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn conversion"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('operators-conversion-tabs'), _vm._v(" "), _c('StatisticTable', {
    ref: "statisticTable",
    attrs: {
      "headColumns": _vm.headColumns,
      "footColumns": _vm.footColumns,
      "rows": _vm.rows,
      "title": ("" + (_vm.$t('pages.operator_conversions')))
    },
    on: {
      "isPopup": _vm.isPopup
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c14aa318"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/operators/conversions/Conversion.vue
// module id = 593
// module chunks = 0